import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

export const CellCurrencyBase = ({
  empty = '-',
  currency = 'USD',
  ...props
}: TableInheritedProps & { empty?: string; currency?: string }) => {
  const { locale } = useTranslation();
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const value = useMemo(() => {
    const number = parseFloat(getValue!());
    if (isNaN(number)) {
      return empty;
    }
    return new Intl.NumberFormat(locale.replaceAll('_', '-'), {
      style: 'currency',
      currency
    }).format(number);
  }, [empty, getValue, locale, currency]);

  return <div {...inheritedProps}>{value}</div>;
};

export const CellCurrency = (props: TableInheritedProps) =>
  useGlobalComponent('CellCurrency', CellCurrencyBase, props);
